<li
  [ngClass]="
  {
    'disabled': uiState && uiState[feature] && uiState[feature].disabled,
    'hidden': uiState && uiState[feature] && uiState[feature].hidden,
    'locked': uiState && uiState[feature] && uiState[feature].locked,
    'active': uiState && uiState[feature] && uiState[feature].active
  }" 
  class="asg-desktop-menu-item">
  <input type="file" onclick="value = null" (change)="uploadFile($event)" [accept]="ACCEPTED_FORMATS" #fileUpload [hidden]="true">
  <a [asgClickHandler]="selectFile">
    <i [ngClass]="UPLOAD_TYPES === TYPES.KES ? 'fas fa-file-download' : 'fas fa-folder-open' "></i>
    @if (UPLOAD_TYPES === TYPES.PDF) {
      {{'MAINMENU.OPEN' | translate }}
    }
    @if (UPLOAD_TYPES === TYPES.KES) {
      {{'MAINMENU.IMPORTKES' | translate }}
    }
    @if (UPLOAD_TYPES === TYPES.OCR) {
      {{'MAINMENU.SCANOCRMENU.OCRFILE' | translate }}
    }
  </a>
</li>
